// extracted by mini-css-extract-plugin
export var readonly = "_ih-1";
export var star = "_ih-0";